var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconRefresh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1363_3357)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.0003 23.3334C11.3948 23.3334 9.18783 22.4292 7.37949 20.6209C5.57116 18.8126 4.66699 16.6056 4.66699 14.0001C4.66699 11.3945 5.57116 9.18758 7.37949 7.37925C9.18783 5.57091 11.3948 4.66675 14.0003 4.66675C15.342 4.66675 16.6253 4.94383 17.8503 5.498C19.0753 6.05216 20.1253 6.84453 21.0003 7.87508V4.66675H23.3337V12.8334H15.167V10.5001H20.067C19.4448 9.41119 18.5941 8.55564 17.5149 7.93341C16.4357 7.31119 15.2642 7.00008 14.0003 7.00008C12.0559 7.00008 10.4031 7.68064 9.04199 9.04175C7.68088 10.4029 7.00033 12.0556 7.00033 14.0001C7.00033 15.9445 7.68088 17.5973 9.04199 18.9584C10.4031 20.3195 12.0559 21.0001 14.0003 21.0001C15.4975 21.0001 16.8489 20.5723 18.0545 19.7167C19.26 18.8612 20.1059 17.7334 20.592 16.3334H23.042C22.4975 18.3945 21.3892 20.0765 19.717 21.3792C18.0448 22.682 16.1392 23.3334 14.0003 23.3334Z",
    fill: "#7B8389"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1363_3357"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRefresh);
export default __webpack_public_path__ + "static/media/icon_refresh.98341fdb0aa51a20255f7a4c678723e0.svg";
export { ForwardRef as ReactComponent };